// Route access decision for protected pages (e.g. /queue). Pure: decide only once every async layer has
// reported — the lazily loaded wallet shell (walletReady), the adapter→context sync (isWalletPending),
// the server auth session and the subscription fetch. Deciding earlier redirected a subscribed merchant
// who reloaded /queue to Home (the default context looks "logged out").

// 'sign_in': a wallet is connected but this account page needs a signed-in session (task 175)
export type RouteAccess = 'allow' | 'loading' | 'redirect' | 'gate' | 'sign_in';

export type RouteAccessInput = Readonly<{
  readonly requireAuth: boolean;
  readonly requiredFeature: string | undefined;
  readonly walletReady: boolean;          // wallet provider loaded (PersistentWallet lazy-loads it)
  readonly isReconnecting: boolean;       // adapter restoring a previous connection
  readonly isWalletPending: boolean;      // adapter connected, context not synced yet
  readonly hasWallet: boolean;            // context has a connected wallet
  readonly authActive: boolean;
  readonly hasSession: boolean;           // server auth session id received
  readonly restoringSession: boolean;     // checking a session saved by an earlier sign-in
  readonly subscriptionKnown: boolean;    // subscription status fetched (or failed)
  readonly hasFeature: boolean;
}>;

export const decideRouteAccess = (i: RouteAccessInput): RouteAccess => {
  if (i.requireAuth) {
    if (!i.walletReady || i.isReconnecting || i.isWalletPending) return 'loading';
    if (!i.hasWallet || !i.authActive) return 'redirect';
  }
  if (i.requiredFeature !== undefined) {
    if (!i.hasSession) return i.restoringSession ? 'loading' : 'sign_in';
    if (!i.subscriptionKnown) return 'loading';
    if (!i.hasFeature) return 'gate';
  }
  return 'allow';
};
